import { BillingAddress } from '@/components/DisplayAddress/BillingAddress'
import { useCheckoutContext } from '@/contexts/checkout/useCheckoutContext'

const CustomerBillingAddress = () => {
  const { billingInfo } = useCheckoutContext()

  return (
    <div className="checkout-step1-section__wrapper mt-4 mb-4">
      <BillingAddress data={billingInfo} />
    </div>
  )
}

export default CustomerBillingAddress
